import React, { ChangeEvent, useEffect, useRef } from 'react';
import { StepComponentProps } from '../wizard.model';
import './nickname-step.scss';
import { Input, InputRef } from 'antd';
import InfoIcon from '@svg/info-circle.svg?react';

const NicknameStep: React.FC<StepComponentProps> = ({ data, onDataChange, errorMessage }) => {
    const inputRef = useRef<InputRef>(null);

    useEffect(() => {
        inputRef.current?.focus();
    }, []);

    const handleNicknameChange = (e: ChangeEvent<HTMLInputElement>) => {
        onDataChange({ nickname: e.target.value });
    };

    return (
        <div className="step">
            <div className="step-header">Give it a nickname</div>
            <div className="step-desc">Next, let’s give this connection it’s own unique nickname.
                <br/>This could be any unique identifier such as an address, city, building or landmark.
            </div>
            <div className="step-content">
                <div className="nickname-wrapper">
                    <Input
                        ref={inputRef}
                        placeholder={data.connection?.serviceName || data.connection?.adiCircuitId}
                        type="text"
                        value={data.nickname}
                        onChange={handleNicknameChange}
                        maxLength={25}
                    />
                    {errorMessage && (
                        <div className="validate-error">
                            <InfoIcon />
                            {errorMessage}
                        </div>
                    )}
                </div>
                <div className="input-hint">
                    You can rename your connection at any time
                </div>
            </div>
        </div>
    );
};

export default NicknameStep;